import { getPresets } from '@indriver/vandermeer';
import { variables } from '@indriver/yrel';
import styled from '../../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { headingPreset, marketingHeadingPreset } from './heading.preset.js';

var defaultStyle = getPresets(headingPreset, {
  fontSize: 'size',
  lineHeight: 'size',
  margin: 'margin'
});
var marketingStyle = getPresets(marketingHeadingPreset, {
  fontSize: 'size',
  lineHeight: 'size',
  margin: 'margin'
});

var style = function style(props) {
  return props.fontType === 'marketing' ? marketingStyle : defaultStyle;
};

var StyledTextForHeading = /*#__PURE__*/styled("h1")({
  name: "StyledTextForHeading",
  class: "s1h356vf",
  vars: {
    "s1h356vf-0": [function (props) {
      return style(props).fontFamily(props);
    }],
    "s1h356vf-1": [function (props) {
      return style(props).fontSize(props);
    }],
    "s1h356vf-2": [function (props) {
      return style(props).lineHeight(props);
    }],
    "s1h356vf-3": [function (props) {
      return style(props).fontWeight(props);
    }],
    "s1h356vf-4": [function (props) {
      return props.margin ? style(props).margin(props) : '0';
    }],
    "s1h356vf-5": [function (_ref) {
      var color = _ref.color;
      return color != null ? color : variables['text-and-icon-primary'];
    }]
  }
});

export { StyledTextForHeading };


require('../../../styles-linaria/typography/heading/heading.styles.css');
